const volumeControlTemplate = ({accessBtnVolume, volumeIndex, accessVolumeSlider}) => `<button type="button" title="${accessBtnVolume}" class="volume ui volume-button-high-glyph control-button tertiary-button" tabindex="${volumeIndex}"></button>
<div class="volume-slider-container volume-slider-hidden">
   <div class="volume-slider-track"></div>
   <div class="button volume-slider" role="slider" aria-label="${accessVolumeSlider}"></div>
</div>`;

export default volumeControlTemplate;
